import { RootState, useAppDispatch, useAppSelector, setSelectedView } from "@hypexone/uicore";
import { competitionViewMenuOptions } from "../../../utils/constants/header.constants";
import FilterIconWhite from "../../../assets/icons/filter-icon-white.svg";
import MenuComponent from "./MenuComponent";
import { useState } from "react";
import { isDesktop, isMobile } from "react-device-detect";
import { useLocation } from "react-router-dom";
import { IN_PLAY_ROUTE } from "@hypexone/uicore";
import Cricket from "../../../assets/images/sports_svgs/cricket_svg.svg"
import Football from "../../../assets/images/sports_svgs/football_svg.svg"
import Tennis from "../../../assets/images/sports_svgs/tennis_svg.svg"
import Casino from "../../../assets/images/sports_svgs/casino_svg.png"
import HorseRacing from "../../../assets/images/sports_svgs/horse_racing_svg.svg"
import GreyhoundRacing from "../../../assets/images/sports_svgs/greyhound_svg.png"
import Binary from "../../../assets/images/sports_svgs/binary_svg.png"
import Politics from "../../../assets/images/sports_svgs/politics_svg.png"
import Basketball from "../../../assets/images/sports_svgs/basketball_svg.png"
import Baseball from "../../../assets/images/sports_svgs/baseball_svg.png"
import TableTennis from "../../../assets/images/sports_svgs/tableTennis_svg.png"
import Volleyball from "../../../assets/images/sports_svgs/volleyball_svg.png"
import IceHockey from "../../../assets/images/sports_svgs/icehockey_svg.png"
import MMA from "../../../assets/images/sports_svgs/martialArts_svg.png"
import Rugby from "../../../assets/images/sports_svgs/rugby_svg.png"
import Darts from "../../../assets/images/sports_svgs/darts_svg.png"
import futsal from "../../../assets/images/sports_svgs/futsal_svg.png"
interface LiveVirtualFilterProps {
  pageTitle?: string;
  hasViewByButton?: boolean;
  isLive?: boolean;
  isVirtual?: boolean;
  isPremium?: boolean;
  onFilterChange: any;
}

const LiveVirtualFilter: React.FC<LiveVirtualFilterProps> = ({
  pageTitle,
  hasViewByButton = true,
  isLive,
  isVirtual,
  isPremium,
  onFilterChange,
}) => {
  const pathName = useLocation().pathname;
  const { selectedView } = useAppSelector(
    (state: RootState) => state.catalog
  );

  const dispatch = useAppDispatch();

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const isInplayRoute = pathName === `${IN_PLAY_ROUTE}`;

  const handleLiveChange = () => {
    onFilterChange(!isLive, isVirtual, isPremium);
  };

  const handleVirtualChange = () => {
    onFilterChange(isLive, !isVirtual, isPremium);
  };

  const handlePremiumChange = () => {
    onFilterChange(isLive, isVirtual, !isPremium);
  };

  const {langData} = useAppSelector((state) => state.cms);
const sportImages: { [key: string]: string } = {
  cricket: Cricket,
  football: Football,
  tennis: Tennis,
  casino: Casino,
  horseracing: HorseRacing,
  greyhoundracing: GreyhoundRacing,
  binary: Binary,
  politics: Politics,
  basketball: Basketball,
  baseball: Baseball,
  tabletennis: TableTennis,
  volleyball: Volleyball,
  icehockey: IceHockey,
  futsal: futsal,
  mma: MMA,
  rugby: Rugby,
  darts: Darts,
};

const normalizeTitle = (title: string) =>
   title?.toLowerCase().replace(/\s+/g, "");



  return (
    <div
      className={`flex items-center gap-3 md:mt-0 mt-[2px] py-1 text-xs text-white md:bg-blue4 px-2 ${
        pageTitle ? "justify-between" : "justify-end"
      }
        ${isDesktop || (isMobile && isInplayRoute) ? "bg-blue4" : "bg-black1"}
        `}
    >
      {/* Page Title */}
      {pageTitle && (
        <div className="font-bold flex gap-1 items-center">
        {isDesktop &&  <img
      src={sportImages[normalizeTitle(pageTitle)] || ""}
      alt={pageTitle}
      className="w-5 h-5 object-contain invert"
    />}  {isMobile && !isInplayRoute ? "Highlights" : pageTitle}
        </div>
      )}

      {/* Conditionally render the LiveVirtualFilter only if IsOnlyTitle is false */}
      {
        <div className="flex flex-col items-end gap-2">
          <div className="flex items-center gap-2">
            <p
              className={`flex gap-1 items-center justify-center border rounded-full px-2 py-[3px] cursor-pointer ${
                isLive
                  ? "bg-green2 text-white border-transparent"
                  : "border-white"
              }`}
              onClick={handleLiveChange}
            >
              <span>{isLive ? "+" : "-"}</span>
              <span>{langData?.['live']}</span>
            </p>

            <p
              className={`flex gap-1 items-center justify-center border rounded-full px-2 py-[2px] min-w-20 cursor-pointer ${
                isVirtual
                  ? "bg-green2 text-white border-transparent"
                  : "border-white"
              }`}
              onClick={handleVirtualChange}
            >
              <span>{isVirtual ? "+" : "-"}</span>
              <span>{langData?.['virtual']}</span>
            </p>

            <p
              className={`flex gap-1 items-center justify-center border rounded-full px-2 py-[2px] min-w-20 cursor-pointer ${
                isPremium
                  ? "bg-green2 text-white border-transparent"
                  : "border-white"
              }`}
              onClick={handlePremiumChange}
            >
              <span>{isPremium ? "+" : "-"}</span>
              <span>{langData?.['premium']}</span>
            </p>
          </div>

          {hasViewByButton && (
            <div className="relative">
              <MenuComponent
                menuTitle="VIEW BY"
                menuList={
                  <div className="flex flex-col gap-1">
                    {competitionViewMenuOptions.map((menuItem) => {
                      return (
                        <div
                          key={menuItem}
                          className={`flex justify-center text-xs px-8 cursor-pointer py-1.5 rounded-md font-bold ${
                            menuItem === selectedView
                              ? "bg-red6 text-white"
                              : "text-black hover:bg-gray1"
                          }`}
                          onClick={() =>
                            dispatch(setSelectedView(menuItem))
                          }
                        >
                          {menuItem}
                        </div>
                      );
                    })}
                  </div>
                }
                customImage={{
                  imagePosition: "left",
                  imageSrc: FilterIconWhite,
                }}
                customButtonCss="bg-gradient-to-b from-red1 to-red5"
                toggleMenu={() => setIsMenuOpen(!isMenuOpen)}
                isOpen={isMenuOpen}
                closeMenu={() => setIsMenuOpen(false)}
              />
            </div>
          )}
        </div>
      }
    </div>
  );
};

export default LiveVirtualFilter;
